import {
    addRentRequest,
    deleteRentRequest,
    editRentRequest,
    getRentListRequest,
    getRentRequest,
    updateRentRequest,
} from '../../../services/network/rent';

class CommonRentService {
    async addRent(values) {
        return await addRentRequest(values);
    }

    async getRent(id) {
        return await getRentRequest(id);
    }

    async getRentList(payload) {
        return await getRentListRequest(payload);
    }

    async deleteRent(id) {
        return await deleteRentRequest(id);
    }

    async editRent(updates) {
        return await editRentRequest(updates);
    }

    async updateRent(updates) {
        return await updateRentRequest(updates);
    }
}

export const RentService = new CommonRentService();
